<template>
  <div>
    <Newsletter
      v-for="newsletterInfo in activeNewsletters"
      :data="newsletterInfo"
    />
  </div>
</template>
<script>
import dynamicLocalization from "@/mixins/dynamic-localization";
import Newsletter from "./Newsletter.vue";

const activeNewsletters = [
  require("./essen-2025.08/data.yml"),
  require("./essen-2025.05/data.yml"),
  require("./essen-2025.04/data.yml"),
  require("./essen-2025.03/data.yml"),
  require("./2025.02/data.yml"),
  require("./2024.07/data.yml"),
];

export default {
  mixins: [dynamicLocalization],
  components: { Newsletter },
  data() {
    return {
      activeNewsletters,
    };
  },
};
</script>
<i18n src="./i18n.json" />
<i18n src="@/locales/global.json" />
